@let hasMoreThanOne = hasMoreThanOneElSg();
@let firstElValue = firstElValueSg();

@if (hasMoreThanOne) {
  <span class="atn-ds-table-cell-value-list__details"
    ><i>Open details to view</i></span
  >
} @else {
  <atn-ds-tag [text]="firstElValue" />
}
